import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { azn } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Gift, Copy, Check, Users } from "lucide-react";

export default function ReferralCard() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referrals").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const link = `${window.location.origin}/register?ref=${data.code}`;

  const copy = () => {
    navigator.clipboard?.writeText(link);
    setCopied(true);
    toast.success("Dəvət linki kopyalandı!");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="rounded-2xl border border-accent/40 bg-card overflow-hidden mb-8" data-testid="referral-card">
      <div className="p-6 flex flex-col lg:flex-row gap-6 items-start lg:items-center justify-between">
        <div className="flex items-start gap-4">
          <span className="w-12 h-12 rounded-xl bg-accent/15 flex items-center justify-center shrink-0">
            <Gift className="w-6 h-6 text-accent" />
          </span>
          <div>
            <h3 className="font-heading text-lg font-bold">Dəvət et və <span className="text-accent">{data.percent}% qazan</span></h3>
            <p className="text-muted-foreground text-sm mt-0.5">
              Dostunuz linkinizlə qeydiyyatdan keçib depozit etdikcə, hər depozitin {data.percent}%-i balansınıza gəlir.
            </p>
            <div className="flex items-center gap-2 mt-3">
              <div className="px-3 py-2 rounded-lg bg-secondary text-sm font-mono truncate max-w-[240px] sm:max-w-sm" data-testid="referral-link">{link}</div>
              <Button size="icon" variant="outline" className="rounded-lg shrink-0" onClick={copy} data-testid="copy-referral-btn">
                {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
              </Button>
            </div>
          </div>
        </div>
        <div className="flex gap-6 shrink-0">
          <div className="text-center">
            <p className="font-heading text-2xl font-bold flex items-center gap-1" data-testid="referral-count"><Users className="w-4 h-4 text-muted-foreground" />{data.total_referrals}</p>
            <p className="text-xs text-muted-foreground">Dəvət edilən</p>
          </div>
          <div className="text-center">
            <p className="font-heading text-2xl font-bold text-accent" data-testid="referral-bonus">{azn(data.total_bonus)}</p>
            <p className="text-xs text-muted-foreground">Qazanılan bonus</p>
          </div>
        </div>
      </div>
    </div>
  );
}
